<template>
	<div class="product-row">
		<div class="font-weight-bold text-lg text-gray-800">
			<span>
				{{ data.product_data.name }}
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'productColumn',
	props: {
		data: {
			type: Object,
			default: null,
		},
	},
};
</script>

<style lang="scss" scoped>
.product-row {
	width: 150px;
}
</style>
